<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">
				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
                        <div class="row">
                            <div class="col-md-4">
                                <h2 class="text-white pb-2 fw-bold">Data Luas Tanam Padi</h2>
                                <!-- <h5 class="text-white op-7 mb-2">Jumlah Penduduk : 310988 / Konsumsi Kg/Kap/Th : 98.6 </h5> -->
                            </div>
                            <div class="col-md-4">
                                <select @change="getTahun()" class="form-control" v-model="form.master_komoditi_id">
                                    <option v-for="data in list_master_komoditi_id" :key="data.master_komoditi_id" :value="data.master_komoditi_id">Data Produksi {{data.uraian}}</option>
                                </select>
                                <br>
                            </div>
                            <div class="col-md-4">
                                
                                    <div class="input-group">
										<select @change="getTahun()" class="form-control" v-model="form.thn">
                                            <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                        </select>
										<div class="input-group-append">
											<!-- <button class="btn btn-primary" type="button" title="Tambah Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button> -->
                                            <button class="btn btn-info" title="Edit Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>
										</div>
									</div>
                                <br>
                            </div>
                          
                        </div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">
                        <table class="table-kiken table table-head-bg-info" width="100%" >
							<thead>
                                <tr class="bg-primary text-center">
									<th scope="col" rowspan="2" style="width: 5%">No</th>
                                    <th scope="col" rowspan="2" style="width: 25%">Kecamatan</th>
									<th scope="col" colspan="12">BULAN</th>
                                    <th scope="col" rowspan="2" style="width: 10%">#</th>      
								</tr>
								<tr class="bg-primary">
									<th scope="col" style="width: 5%">1</th>
                                    <th scope="col" style="width: 5%">2</th>
                                    <th scope="col" style="width: 5%">3</th>
                                    <th scope="col" style="width: 5%">4</th>
                                    <th scope="col" style="width: 5%">5</th>
                                    <th scope="col" style="width: 5%">6</th>
                                    <th scope="col" style="width: 5%">7</th>
                                    <th scope="col" style="width: 5%">8</th>
                                    <th scope="col" style="width: 5%">9</th>
                                    <th scope="col" style="width: 5%">10</th>
                                    <th scope="col" style="width: 5%">11</th>
                                    <th scope="col" style="width: 5%">12</th>
								</tr>
							</thead>
							<tbody>
								<tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
									<td class="text-center">{{index+1}}</td>
									<td >{{data.nama_kecamatan}}</td>
                                    <td class="text-center">{{data[1]}}</td>
                                    <td class="text-center">{{data[2]}}</td>
                                    <td class="text-center">{{data[3]}}</td>
                                    <td class="text-center">{{data[4]}}</td>
                                    <td class="text-center">{{data[5]}}</td>
                                    <td class="text-center">{{data[6]}}</td>
                                    <td class="text-center">{{data[7]}}</td>
                                    <td class="text-center">{{data[8]}}</td>
                                    <td class="text-center">{{data[9]}}</td>
                                    <td class="text-center">{{data[10]}}</td>
                                    <td class="text-center">{{data[10]}}</td>
                                    <td class="text-center">{{data[12]}}</td>
                                    <td class="text-center">
                                        <!-- <button v-if="Chk_Add(data)" @click="selectDataAdd(data)" class="btn btn-info btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button> -->
                                        <!-- &nbsp; -->
                                        <button v-if="!Chk_Add(data)" @click="selectData(data)" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                    </td>
								</tr>

							</tbody>
						</table>

                       
					</div>
				</div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">ATUR DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">
                                        <div>
                                            <span class="huruf_input">Kecamatan</span>
                                            <autocomplete
                                                :url="URL+ 'api/v1/statistik_ketapang_master_kecamatan/autocomplete'"
                                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                                anchor="nama_kecamatan"
                                                :initValue="form.nama_kecamatan"
                                                :placeholder="'Cari Kecamatan'"
                                                :classes="{ input: 'form-control'}"
                                                label="writer"
                                                :onShouldRenderChild="renderChild"
                                                :on-select="getAuto">
                                            </autocomplete>
                                            <hr>
                                            <table class="table-kiken table table-head-bg-info" width="100%" >
                                                <thead>
                                                    <tr class="bg-primary text-center">
                                                        <th scope="col" style="width: 5%">No</th>
                                                        <th scope="col" style="width: 30%">Uraian</th>
                                                        <th scope="col" style="width: 65%"></th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">1</td>
                                                        <td>Januari</td>
                                                        <td class="text-center">
                                                            <input v-model="form[1]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">2</td>
                                                        <td>Februari</td>
                                                        <td class="text-center">
                                                            <input v-model="form[2]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">3</td>
                                                        <td>Maret</td>
                                                        <td class="text-center">
                                                            <input v-model="form[3]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">4</td>
                                                        <td>April</td>
                                                        <td class="text-center">
                                                            <input v-model="form[4]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">5</td>
                                                        <td>Mei</td>
                                                        <td class="text-center">
                                                            <input v-model="form[5]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">6</td>
                                                        <td>Juni</td>
                                                        <td class="text-center">
                                                            <input v-model="form[6]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">7</td>
                                                        <td>Juli</td>
                                                        <td class="text-center">
                                                            <input v-model="form[7]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">8</td>
                                                        <td>Agustus</td>
                                                        <td class="text-center">
                                                            <input v-model="form[8]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">9</td>
                                                        <td>September</td>
                                                        <td class="text-center">
                                                            <input v-model="form[9]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">10</td>
                                                        <td>Oktober</td>
                                                        <td class="text-center">
                                                            <input v-model="form[10]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">11</td>
                                                        <td>November</td>
                                                        <td class="text-center">
                                                            <input v-model="form[11]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">12</td>
                                                        <td>Desember</td>
                                                        <td class="text-center">
                                                            <input v-model="form[12]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                            <hr>
                                        
                                            <span class="huruf_input">Keteranganxx</span>
                                            <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-info btn-md">Simpan</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">ATUR DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div v-if="cek_edit">
                                            <span class="huruf_input">Kecamatan</span>
                                            <autocomplete
                                                :url="URL+ 'api/v1/statistik_ketapang_master_kecamatan/autocomplete'"
                                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                                anchor="nama_kecamatan"
                                                :initValue="form.nama_kecamatan"
                                                :placeholder="'Cari Kecamatan'"
                                                :classes="{ input: 'form-control'}"
                                                label="writer"
                                                :onShouldRenderChild="renderChild"
                                                :on-select="getAuto">
                                            </autocomplete>
                                            <hr>
                                            <table class="table-kiken table table-head-bg-warning" width="100%" >
                                                <thead>
                                                    <tr class="bg-primary text-center">
                                                        <th scope="col" style="width: 5%">No</th>
                                                        <th scope="col" style="width: 30%">Uraian</th>
                                                        <th scope="col" style="width: 65%"></th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">1</td>
                                                        <td>Januari</td>
                                                        <td class="text-center">
                                                            <input v-model="form[1]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">2</td>
                                                        <td>Februari</td>
                                                        <td class="text-center">
                                                            <input v-model="form[2]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">3</td>
                                                        <td>Maret</td>
                                                        <td class="text-center">
                                                            <input v-model="form[3]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">4</td>
                                                        <td>April</td>
                                                        <td class="text-center">
                                                            <input v-model="form[4]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">5</td>
                                                        <td>Mei</td>
                                                        <td class="text-center">
                                                            <input v-model="form[5]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">6</td>
                                                        <td>Juni</td>
                                                        <td class="text-center">
                                                            <input v-model="form[6]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">7</td>
                                                        <td>Juli</td>
                                                        <td class="text-center">
                                                            <input v-model="form[7]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">8</td>
                                                        <td>Agustus</td>
                                                        <td class="text-center">
                                                            <input v-model="form[8]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">9</td>
                                                        <td>September</td>
                                                        <td class="text-center">
                                                            <input v-model="form[9]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">10</td>
                                                        <td>Oktober</td>
                                                        <td class="text-center">
                                                            <input v-model="form[10]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">11</td>
                                                        <td>November</td>
                                                        <td class="text-center">
                                                            <input v-model="form[11]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">12</td>
                                                        <td>Desember</td>
                                                        <td class="text-center">
                                                            <input v-model="form[12]" style="width:100%" type="number"  step="0.01">
                                                        </td>
                                                    </tr>
                                                    

                                                </tbody>
                                            </table>
                                            <hr>
                                        
                                            <span class="huruf_input">Keteranganxx</span>
                                            <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/statistik_ketapang_luas_tanam_padi/";
const ADD_URL_PRODUKSI = URL_APP + "api/v1/statistik_ketapang_master_komoditi/";
const ADD_URL_DATE = URL_APP + "api/v1/statistik_ketapang_master_thn_bln/";
const FILE_LOAD = URL_APP + "uploads/";
const URL_SERVER = URL_APP;

import Autocomplete from 'vue2-autocomplete-js';

export default {
    components: { Autocomplete },
    data() {
        return {
            data_load : false,
            form : {
                id : '',
                kecamatan_id : '',
                master_komoditi_id : '',
                thn : '',
                1 : 0,
                2 : 0,
                3 : 0,
                4 : 0,
                5 : 0,
                6 : 0,
                7 : 0,
                8 : 0,
                9 : 0,
                10 : 0,
                11 : 0,
                12 : 0,
                keterangan : '-',
                nama_kecamatan : ''

            },
            id :'',
            cek_load_data : true,
            cek_edit : false,
            cek_tambah : false,
            cek_Add : false,
            cek_disabled : false,
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_thn: [],
            list_bln: [],
            list_master_komoditi_id: [],
            


            page_first: 1,
            page_last: 0,
            cari_value: "",

            URL : URL_SERVER,
            token : localStorage.token,
        }
    },
    methods: {
        getView: function() {
            console.log(this.form.master_komoditi_id)
            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    kecamatan_id: this.form.kecamatan_id,
                    master_komoditi_id: this.form.master_komoditi_id,
                    bln: this.form.bln,
                    thn: this.form.thn,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                    this.list_data = res_data;
                    this.cek_load_data = false;

            });
        },

        addData: function() {
            if (this.form.kecamatan_id == null || this.form.kecamatan_id == undefined || this.form.kecamatan_id == '') {
                 this.alertku("error", "Pilih Kecamatan Terlebih Dahulu");
            } else {
                fetch(ADD_URL + "addData", {
                    method: "POST",
                    headers: {
                        'content-type' : 'application/json',
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then(res_data => {
                    this.alertku("success", "sukses menambah data");
                    this.getView();
                });
            }
            
        },

        editData: function() {

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
            this.form = {
                id : data.id,
                kecamatan_id : data.kecamatan_id,
                master_komoditi_id : data.master_komoditi_id,
                nama_kecamatan : data.nama_kecamatan,
                thn : data.thn,
                1 : data[1],
                2 : data[2],
                3 : data[3],
                4 : data[4],
                5 : data[5],
                6 : data[6],
                7 : data[7],
                8 : data[8],
                9 : data[9],
                10 : data[10],
                11 : data[11],
                12 : data[12],
            };

            console.log(data)
            this.cek_edit = true;
            this.cek_tambah = true;
        },
        selectDataAdd: function(data) {

                this.form.id = data.id;
                this.form.kecamatan_id = data.kecamatan_id;
                this.form.nama_kecamatan = data.nama_kecamatan;
                this.form[1] = data[1];
                this.form[2] =  data[2];
                this.form[3] = data[3];
                this.form[4] = data[4];
                this.form[5] = data[5];
                this.form[6] = data[6];
                this.form[7] = data[7];
                this.form[8] = data[8];
                this.form[9] = data[9];
                this.form[10] = data[10];
                this.form[11] = data[11];
                this.form[12] = data[12];
          

            console.log(data)
            this.cek_edit = true;
            this.cek_tambah = true;
        },

        emptyData : function(){
            this.cek_edit = false;
            this.cek_tambah = false;
        },

        Chk_Add : function(data){
            if (data[1] == null || data[1] == undefined) {
                // console.log('kosong')
                return true;
            } 
            else {
                return false;
            }
            
        },
        produksi_final : function(data){
            var f_Pengeluaran_GKG_benih = data.produksi_kotor * data.Pengeluaran_GKG_benih/100;
            var f_Pengeluaran_GKG_pakan_ternak = data.produksi_kotor * data.Pengeluaran_GKG_pakan_ternak/100;
            var f_Pengeluaran_GKG_susut = data.produksi_kotor * data.Pengeluaran_GKG_susut/100;

            var f_Pengeluaran_GKG_BBI = data.produksi_kotor * data.Pengeluaran_GKG_BBI/100;
            var f_Penggunaan_Bersa_pakan_ternak = data.produksi_kotor * data.Penggunaan_Bersa_pakan_ternak/100;
            var f_Penggunaan_Bersa_industri_nm = data.produksi_kotor * data.Penggunaan_Bersa_industri_nm/100;
            var f_Penggunaan_Bersa_susut = data.produksi_kotor * data.Penggunaan_Bersa_susut/100;

            var f_produksi_GKG = data.produksi_kotor-f_Pengeluaran_GKG_benih-f_Pengeluaran_GKG_pakan_ternak-f_Pengeluaran_GKG_susut-f_Pengeluaran_GKG_BBI-f_Penggunaan_Bersa_pakan_ternak-f_Penggunaan_Bersa_industri_nm-f_Penggunaan_Bersa_susut;

            var f_produksi_bersih = f_produksi_GKG * data.bersih/100;

            return {
                Pengeluaran_GKG_benih : f_Pengeluaran_GKG_benih.toFixed(2),
                Pengeluaran_GKG_pakan_ternak : f_Pengeluaran_GKG_pakan_ternak.toFixed(2),
                Pengeluaran_GKG_susut : f_Pengeluaran_GKG_susut.toFixed(2),
                Pengeluaran_GKG_BBI : f_Pengeluaran_GKG_BBI.toFixed(2),

                Penggunaan_Bersa_pakan_ternak : f_Penggunaan_Bersa_pakan_ternak.toFixed(2),
                Penggunaan_Bersa_industri_nm : f_Penggunaan_Bersa_industri_nm.toFixed(2),
                Penggunaan_Bersa_susut : f_Penggunaan_Bersa_susut.toFixed(2),

                produksi_GKG : f_produksi_GKG.toFixed(2),
                produksi_bersih : f_produksi_bersih.toFixed(2),
            }

        },



        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    id: idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },
        ke_alamat : function(data){
            window.open(data);
        },

    // ================== TAMBAHAN ====================

        getProduksi : function(){
            fetch(ADD_URL_PRODUKSI, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                this.list_master_komoditi_id = res_data;
                this.form.master_komoditi_id = res_data[0].master_komoditi_id;
                this.getTahun();
            });
        },
        getTahun : function(){
            fetch(ADD_URL_DATE + "thn", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {

                 this.list_thn = res_data;
                //  this.getBln();
                this.getView();
            });
        },
        getBln : function(){
            fetch(ADD_URL_DATE + "bln", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                 this.list_bln = res_data;
                 this.getView();
            });
        },
        pembulatan : function(a, b){
            var data = a * b/100;
            var hasil = data.toFixed(2);
            return hasil;
        },
        pembulatanX : function(a, b){
            var data = a * b/100;
            return data;
        },
    // ================== TAMBAHAN ====================

    // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${data.nama_kecamatan}</b></span>
            <span style='font-size:80%'>${data.nama_kabupaten}</span>
            `
        },
        getAuto : function(obj){
            this.form.kecamatan_id = obj.kecamatan_id;
            this.getView();
            // console.log(obj);
        },
    // ================== AUTOCOMPLETE ====================


    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }
    // ================== PAGINASI ====================
        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;


        this.getProduksi();
        

        

        var d = new Date();
        // console.log(d.getMonth())
        this.form.thn = d.getFullYear();
        this.form.bln = d.getMonth();


    },

}
</script>